import { createApp } from 'vue';
import Topbar from '@app/components/parts/topBar.vue';
import useI18n from '@/js/utils/I18n';
import { getTranslations } from '@/js/utils/I18n/getTranslations';
import { flashMessage } from '@utils/flashMessage';
import { FlashMessageThemeEnum } from '@/js/enums/FlashMessageThemeEnum';
import Notifications from '@kyvg/vue3-notification';

const translations = {
    search: {
        placeholder: 'nav.search.empty',
        resultAnswer: 'nav.search.result.answer',
        resultCandidate: 'nav.search.result.candidate',
        resultDateAdd: 'nav.search.result.date_add',
    },
};

const has = (): boolean => {
    return document.querySelectorAll('[data-top-bar]').length > 0;
};

const start = async () => {
    const t = await getTranslations(translations);
    const elements = document.querySelectorAll<HTMLElement>('[data-top-bar]');
    for (const el of Array.from(elements)) {
        const props = JSON.parse(el.dataset.props);
        const flashMessages: string[] = el.dataset.flashMessages ? JSON.parse(el.dataset.flashMessages) : [];

        createApp(Topbar, {
            menu: props.menu,
            search: props.search,
            sla: props.sla,
            settings: props.settings,
            notifications: props.notifications,
            lang: t,
            user: props.user,
            admin: props.admin,
            isDev: props.isDev,
            systemMessages: props.systemMessages,
            homepageUrl: props.homepageUrl,
        })
            .use(await useI18n())
            .use(Notifications)
            .mount(el);

        for (const message of flashMessages) {
            flashMessage(FlashMessageThemeEnum.Success, message, undefined, 'top-right');
        }
    }
};
export const init = () => {
    if (has()) {
        start();
    }
};
